<template>
  <v-container
    id="locationTab"
    class="pa-0"
  >
    <base-resource-grid
      ref="resourceGrid"
      color="green"
      icon="mdi-map-marker"
      plural-name="Locations"
      singular-name="Location"
      allow-expand
      :headers="gridHeaders"
      :resource="locationResource"
      :fetch-method="getLocations"
      :actions="actions"
      :prepare-save="prepareSave"
      :disabled="disabled"
      @item-expanded="itemExpanded"
      @handleAction="handleAction"
      @item:updated="itemChanged"
      @item:added="itemChanged"
      @item:deleted="itemChanged"
    >
      <template v-slot:rowExpand="bindings">
        <base-audit-container
          v-show="bindings.details.expandAction !== 'jobClass'"
          :item="bindings.details.item"
        />
        <assign-job-class
          v-show="bindings.details.expandAction === 'jobClass'"
          :open-enrollment="openEnrollment"
          :location="bindings.details.item"
          :disabled="disabled"
        />
      </template>
      <template v-slot:editForm="bindings">
        <v-row>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="bindings.editedItem.locationName"
              :error-messages="bindings.formErrors.LocationName"
              :disabled="disabled"
              label="Name"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="bindings.editedItem.locationAddress"
              :error-messages="bindings.formErrors.LocationAddress"
              :disabled="disabled"
              label="Address"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="bindings.editedItem.locationCity"
              :error-messages="bindings.formErrors.LocationCity"
              :disabled="disabled"
              label="City"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="bindings.editedItem.locationState"
              :error-messages="formErrors.LocationState"
              :disabled="disabled"
              label="State"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="bindings.editedItem.locationZip"
              :error-messages="bindings.formErrors.LocationZip"
              :disabled="disabled"
              label="Zip"
            />
          </v-col>
        </v-row>
      </template>
    </base-resource-grid>
    <base-history-dialog
      resource-endpoint="oeLocationHistory/"
      id-field="oeLocationId"
      title-field="location"
      color="green"
      :columns="historyColumns"
      :item="historyItem"
      @hide="historyItem = null"
    />
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'

  export default {
    name: 'LocationTab',

    components: {
      AssignJobClass: () => import('./AssignJobClass'),
    },

    props: {
      openEnrollment: {
        type: Object,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      formErrors: {
        type: Object,
        default: null,
      },
    },

    data: () => ({
      gridHeaders: [
        {
          text: 'Name',
          value: 'locationName',
        },
        {
          text: 'City',
          value: 'locationCity',
        },
      ],

      historyColumns: [
        {
          text: 'Name',
          value: 'locationName',
        },
        {
          text: 'Address',
          value: 'locationAddress',
        },
        {
          text: 'City',
          value: 'locationCity',
        },
        {
          text: 'State',
          value: 'locationState',
        },
        {
          text: 'Zip',
          value: 'LocationZip',
        },
      ],

      actions: [
        {
          color: 'info',
          icon: 'mdi-information-variant',
          action: 'history',
        },
        {
          color: 'amber',
          icon: 'mdi-account-supervisor',
          action: 'jobClass',
        },
      ],

      locationResource: new TroodyApi('oeLocation/'),

      historyItem: null,

      currentAction: 'history',
    }),

    methods: {
      getLocations () {
        return this.locationResource.query({ openEnrollmentId: this.openEnrollment.id })
      },

      handleAction (action, data) {
        // If we are already on history, show details
        if (action === 'history' && this.currentAction === 'history') {
          this.historyItem = data
        }

        this.$refs.resourceGrid.expand(action, data)
        this.currentAction = action
      },

      itemChanged (data) {
        this.$emit('item:changed', data)
      },

      itemExpanded (data) {
        if (data.value) {
          this.$refs.resourceGrid.expand(this.currentAction, data.item)
        } else {
          this.$refs.resourceGrid.collapse()
        }
      },

      prepareSave (payload) {
        if (payload) {
          payload.openEnrollmentId = this.openEnrollment.id
        }
        return payload
      },
    },
  }
</script>
